module.exports = __webpack_public_path__ + "img/technologies.11a2b80.jpg?v=1747398688961";